<template>
  <section id="content">
    <v-card class="login-card mx-auto" :loading="loading">
      <v-img :src="require('@/assets/logos/VAFURSLOGO_TRANSPARENT.png')" height="304px" contain />
      <v-form @submit.prevent="login">
        <v-container>
          <v-row>
            <v-text-field
              v-model="username"
              type="text"
              label="Email"
              :disabled="loading"
              required
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              required
              :error="!!error"
              :error-messages="error"
              @keyup.enter.native="login"
              :disabled="loading"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-btn
              tile
              color="primary"
              class="ml-auto"
              :disabled="loading"
              @click="login"
            >Login</v-btn>
          </v-row>
          <v-row class="mt-4">
            <v-btn
              tile
              color="secondary"
              class="mx-auto white--text"
              :disabled="loading"
              width="230px"
              @click="showCreateAccount"
            >
              Create Account
            </v-btn>
          </v-row>
          <v-row class="mt-3">
            <v-btn
              tile
              color="#4285F4"
              class="mx-auto pl-2 pr-4 white--text"
              :disabled="loading"
              width="230px"
              @click="googleLogin"
            >
              <v-img :src="require('../assets/google_icon.svg')" height="34px" width="34px" class="px-0" />
              Sign in with Google
            </v-btn>
          </v-row>
          <v-row class="mt-3">
            <v-btn
              text
              class="mx-auto"
              :disabled="loading"
              width="230px"
              @click="resetPassword"
            >
              Forgot Password
            </v-btn>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    <create-account-modal ref="creationModal" :email.sync="username" />
    <reset-password-modal ref="resetModal" :email.sync="username" />
  </section>
</template>

<script>
  import firebase from "firebase/app";
  import CreateAccountModal from "./CreateAccountModal";
  import ResetPasswordModal from "./ResetPasswordModal";

  export default {
    name: 'LoginForm',
    data () {
      return {
        username: '',
        password: '',
        showPassword: false,
        error: undefined,
        loading: false,
      }
    },
    components: {
      CreateAccountModal,
      ResetPasswordModal
    },
    methods: {
      async login () {
        this.loading = true;
        try {
          await firebase.auth().signInWithEmailAndPassword(this.username, this.password)
        } catch(err) {
          this.error = err.message
        }

        this.loading = false;
      },
      async googleLogin () {
          this.loading = true;
        try {
          await firebase.auth()
              .signInWithPopup(new firebase.auth.GoogleAuthProvider());
        } catch(err)  {
          console.error(err)
        }
        this.loading = false;
      },
      async resetPassword() {
          this.$refs.resetModal.showModal(this.username);
      },
      async showCreateAccount() {
          this.$refs.creationModal.showModal(this.username);
      },
    },
  }
</script>
<style>
  .login-card {
    margin-top: calc(50vh - 333px);
    width: 95% !important;
    max-width: 400px !important;
    padding: 1em 3em;
    height: 665px;
  }
</style>
